module.exports = __webpack_public_path__ + "static/media/20_zemli_0_85.56.2fc070e2.png";